import { EventViewData } from 'components/eventView/pages/eventData';

export const KDag2024Event: EventViewData = {
    eventId: 'kdag',
    mapId: '2be3ac7f-940e-4a5e-85d3-9eec9421da83',
    guideId: '8f62e9d8-e428-4a3e-8758-34c1a15fc448',
    mapSettings: {
        standZoom: 0.8
    }
};
